import Breadcrumbs from "components/Common/Breadcrumb"
import FullPageLoader from "components/fullPageLoader"
import posterImage from "../../../assets/images/video/poster-image.png"
import PlayButton from "../../../assets/images/icons/play-button.svg"
import React, { useEffect, useState } from "react"
import { useParams } from "react-router-dom"
import { Card, CardBody, Col, Container, Row } from "reactstrap"
import { useLazyGetPlaylistQuery } from "store/api/investors/reports.api"
import VideoModal from "modals/videoModal"
import { useSelector } from "react-redux"

const Playlist = () => {
  const [trigger, { isFetching }] = useLazyGetPlaylistQuery()
  const { userType } = useSelector((state) => state.user)
  const [playlist, setPlaylist] = useState([])
  const [open, setOpen] = useState(false)
  const [video, setVideo] = useState("")

  const getBlog = async () => {
    try {
      const { data } = await trigger({
        user_type: userType === "INVESTOR" ? "investor" : "wealthPartner",
      }).unwrap()
      setPlaylist(data)
    } catch (error) {}
  }

  useEffect(() => {
    getBlog()
  }, [userType])

  return (
    <>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title={"Play List"} breadcrumbItem={"Play List"} />

          <Row>
            <Col xl={12}>
              {isFetching ? (
                <FullPageLoader />
              ) : (
                <Card>
                  <CardBody>
                    <div className="playlist-wrapper-section">
                      {playlist.map((item, index) => (
                        <div
                          key={`video_${index}`}
                          className="playlist-card-box"
                        >
                          <div className="discover-icd-slider">
                            <img
                              width={"100%"}
                              src={item.thumbnail_url || posterImage}
                              alt=""
                            />
                            <div
                              onClick={() => {
                                setVideo(item)
                                setOpen(true)
                              }}
                              className="play-icon"
                            >
                              <img src={PlayButton} alt="" />
                            </div>
                          </div>
                          <p>{item.title}</p>
                        </div>
                      ))}
                    </div>
                  </CardBody>
                </Card>
              )}
            </Col>
          </Row>
          {open && <VideoModal item={video} open={open} setOpen={setOpen} />}
        </Container>
      </div>
    </>
  )
}

export default Playlist
